import { render, staticRenderFns } from "./total-info.vue?vue&type=template&id=634efc6b&scoped=true"
import script from "./total-info.vue?vue&type=script&lang=js"
export * from "./total-info.vue?vue&type=script&lang=js"
import style0 from "./total-info.vue?vue&type=style&index=0&id=634efc6b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634efc6b",
  null
  
)

export default component.exports